const LISTE_AFFICHEUR = {
  title: 'Liste des afficheurs',
  actions: {
    add: 'Nouvel afficheur',
    search: 'Recherche',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    afficheurs: 'Afficheur(s)',
    archive: 'Archivé',
    yes: 'Oui',
    no: 'Non',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  breadcrumb: {
    racine: 'Accueil',
    listeAfficheur: 'Liste des afficheurs',
  },
  tab: {
    code: 'Code',
    raisonSocial: 'Raison sociale',
    adresse: 'Adresse',
    cp: 'CP',
    ville: 'Ville',
    telephone: 'Téléphone',
    portable: 'Portable',
    email: 'Email',
    compteComptable: 'Code comptable',
    archive: 'Archivé',
    actions: {
      edit: 'Modifier',
      archive: 'Archiver',
      delete: 'Supprimer',
    },
  },
  archivage: {
    titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver cet afficheur ?',
    title: 'Etes-vous sûr de vouloir archiver cet afficheur ?',
    sucessArchivage: 'Afficheur archivé avec succès',
    sucessDesarchivage: 'Afficheur désarchivé avec succès',
  },
};

export default LISTE_AFFICHEUR;
